let elements = {
	"backgrounds": [
		"landscape",
		"night"
	],
	"titles": [
		{
			"id": "#home",
			"page": "/home",
			"name": "Home",
		},
		{
			"name": "Who am I ?"
		},
		{
			"id": "#resume",
			"page": "/resume",
			"name": "Resume",
		}, 
		{
			"name": "Works"
		},
		{
			"id": "#skills",
			"page": "/skills",
			"name": "Skills",
		},
		{
			"id": "#languages",
			"page": "/languages",
			"name": "Languages",
		},
		{
			"id": "#projects",
			"page": "/projects",
			"name": "Projects",
		},
		{
			"id": "#awards",
			"page": "/awards",
			"name": "Awards",
		},
		{
			"id": "#contact",
			"page": "/contact",
			"name": "Contact",
		}
	]
  }
  
export default elements;
